const completed = 'COMPLETED';
const inWork = 'IN_WORK';
const request = 'REQUEST';

export const DRAFT_STAGE_DICT = Object.freeze({
    completed,
    inWork,
    request,
});
